import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {LanguageContext} from './localization';
import {localizePublicLink} from './localization/publicRoutes';
export default function PublicLink({to, children, ...props}) {
  const {locale} = useContext(LanguageContext);
  if (typeof to === 'string' && to.startsWith('/guides/')) return <a href={localizePublicLink(to, locale)} {...props}>{children}</a>;
  return <Link to={localizePublicLink(to, locale)} {...props}>{children}</Link>;
}
